import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { deleteUser } from '../../react-redux/Slicer/userSlice';
import './Header.css';

// Minimal T2T-styled title bar for the user-management (admin) screens.
//
// OSIF's Header/Asidebar were removed during the T2T separation. These admin
// screens now render inside the T2T layout (T2TLayout provides the sidebar), so
// this component only supplies a page title bar, a control to open the T2T
// sidebar on mobile, a back button, and a logout.
const Header = ({ title }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const openSidebar = () => {
    document.getElementById('t2t-sidebar')?.classList.add('open');
    document.getElementById('t2t-backdrop')?.classList.add('open');
  };

  const handleLogout = () => {
    const loginType = localStorage.getItem('login_type');
    localStorage.clear();
    sessionStorage.clear();
    if (loginType) localStorage.setItem('login_type', loginType);
    dispatch(deleteUser());
    navigate('/');
  };

  return (
    <div
      className="t2t-admin-header d-flex align-items-center justify-content-between px-3 py-2"
      style={{
        background: '#fff',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={openSidebar}
          className="btn btn-link p-0 d-lg-none"
          aria-label="Open menu"
          style={{ fontSize: 20, color: '#374151' }}
        >
          <i className="bi bi-list"></i>
        </button>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-link p-0"
          aria-label="Back"
          style={{ fontSize: 18, color: '#374151' }}
        >
          <i className="bi bi-arrow-left"></i>
        </button>
        <h5 className="m-0" style={{ fontWeight: 600, color: '#111827' }}>{title}</h5>
      </div>
      <button
        onClick={handleLogout}
        className="btn btn-link p-0"
        title="Logout"
        aria-label="Logout"
        style={{ fontSize: 18, color: '#DC2626' }}
      >
        <i className="bi bi-power"></i>
      </button>
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string,
};

Header.defaultProps = {
  title: '',
};

export default Header;
